export default __webpack_public_path__ + "static/media/border-tip-right.acc48d33.png";